/**
 * Peças que faltaram ao concluir uma etapa (pedido da Rekar no teste do
 * tablet: concluir 20 de 40 não pode fazer as outras 20 sumirem).
 *
 * Cada etapa sabe quantas peças chegam nela (`esperada`: o lote, ou o que a
 * etapa anterior entregou). Ao concluir com menos, o operador diz o destino:
 *  - "saldo": as peças ficam para depois, numa ficha de saldo na mesma etapa;
 *  - "perda": defeito, erro de máquina…, com o motivo cadastrado.
 * Em qualquer caso a etapa seguinte recebe só o que foi produzido.
 *
 * Peça a mais não existe: a ficha segue a caixa (múltiplos de 80 no volante)
 * e o ERP só dá baixa na quantidade da ficha. Apontar acima do esperado é
 * recusado (também protege a avaliação de produção inflada).
 */
export const DESTINOS_FALTA = ['saldo', 'perda'];
/** O aviso do tablet e do servidor quando passa da ficha. */
export function avisoAcimaDaFicha(esperada, restante) {
    return restante === 0
        ? `As ${esperada} peças da ficha já foram apontadas.`
        : `A ficha tem só ${esperada} peças: ${restante === 1 ? 'falta 1' : `faltam ${restante}`}.`;
}
export class AcimaDaFichaError extends Error {
    esperada;
    restante;
    constructor(esperada, restante) {
        super(avisoAcimaDaFicha(esperada, restante));
        this.esperada = esperada;
        this.restante = restante;
    }
}
/** Quanto ainda dá para apontar nesta etapa. */
export function restanteDaFicha(entrada) {
    return Math.max(0, entrada.esperada - entrada.jaApontada);
}
/** Recusa apontar (ou concluir com) mais peças do que a etapa espera. */
export function conferirLimiteDaFicha(entrada) {
    const restante = restanteDaFicha(entrada);
    if (entrada.quantidade > restante)
        throw new AcimaDaFichaError(entrada.esperada, restante);
}
export class DestinoFaltaAusenteError extends Error {
    falta;
    constructor(falta) {
        super(`Faltaram ${falta} ${falta === 1 ? 'peça' : 'peças'}: diga se ficam para depois ou se foram perda.`);
        this.falta = falta;
    }
}
export function faltaAoConcluir(entrada) {
    const produzida = Math.max(0, entrada.produzida);
    const falta = Math.max(0, entrada.esperada - produzida);
    if (falta > 0 && !entrada.destino)
        throw new DestinoFaltaAusenteError(falta);
    return {
        falta,
        saldo: entrada.destino === 'saldo' ? falta : 0,
        perda: entrada.destino === 'perda' ? falta : 0,
        proximaEsperada: produzida,
    };
}
//# sourceMappingURL=falta.js.map